export const FIRST_IDS = [1, 9, 15, 21, 27, 33, 41, 47, 53, 59];
export const LAST_IDS = [8, 14, 20, 26, 32, 40, 46, 52, 58, 65];
export const getIntrospectionNumber = (programId, introspectionId) => {
  const mapping = {
    1: introspectionId,
    2: introspectionId - 32,
    3: introspectionId - 8,
    4: introspectionId - 14,
    5: introspectionId - 20,
    6: introspectionId - 26,
    7: introspectionId - 40,
    8: introspectionId - 46,
    9: introspectionId - 52,
    10: introspectionId - 58,
  };
  return mapping[Number(programId)] ?? null;
};
